import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
let modules = {};

const requireAll = requireContext => {
    requireContext.keys().forEach((key) => {
        // 通过 requireContext(key)导出文件内容
        const mod = requireContext(key)
        modules[key.slice(key.lastIndexOf('/') + 1, -3).toLocaleLowerCase()] = mod.__esModule && mod.default ? mod.default : mod
    })
};
const req_controller = require.context('./modules', true, /\.js$/);
requireAll(req_controller);

Vue.use(Vuex);
//store有四个属性：state、getters，mutations，actions
const store = new Vuex.Store({
    //modules让每一个store模块都能拥有自己的state，mutation，getters,actions,这样的方式结构更加清晰
    modules,
    getters
});

export default store;
